export const GLOBAL_ACTIONS = {
  GLOBAL_STATE_UPDATE: 'GLOBAL_STATE_UPDATE'
}

export const updateGlobalState = (payload) => ({
  type: GLOBAL_ACTIONS.GLOBAL_STATE_UPDATE,
  payload
})
